// Port of api/fuel/app/classes/filter/package/games/game/prepare/expansions.php
export default {
	run: function(local, global) {
		local.expansions = (global.expansions && global.expansions[local.game_id]) ? global.expansions[local.game_id].length : 0
		return local
	}
}
